const QUERY_KEY_PREFIX = "magic-links";

export const MAGIC_LINKS_QUERY_KEYS = {
  all: [QUERY_KEY_PREFIX] as const,
  byEntity: (
    type: string,
    entityIdPublic: string,
  ): readonly [string, string, string, string] =>
    [QUERY_KEY_PREFIX, "entity", type, entityIdPublic] as const,
} as const;
